<template>
  <div class="upload-new-button" data-testid="upload-new-button">
    <label for="upload-document" class="upload-new-button__label" data-testid="upload-new-button-label">
      <UploadIcon class="upload-new-button__icon" />
      <span class="upload-new-button__text">{{ $t('client.share_dialog.cta.upload') }}</span>
    </label>
    <input type="file"
           class="upload-new-button__input"
           id="upload-document"
           name="upload-document"
           data-testid="upload-new-button-input"
           @change="$emit('onUploadedNewValidated', addFiles($event.target.files))"
           accept="*/*"
           ref="input"
           multiple>
  </div>
</template>

<script>
import { typeValidate, sizeValidate, uniqueId } from '../helpers';
import { SUPPORTED_TYPES, MAX_FILE_SIZE_MB, WILDCARD_MAX_FILE_SIZE_MB } from '@/modules/filesUploader/constants/index';

export default {
  name: 'UploadNew',
  components: {
    UploadIcon: () => import('@/assets/images/svg/icons-misc/upload.svg'),
  },
  computed: {
    canUploadVideosFF() {
      return this.$hasFeature('can_upload_videos')
    },
    allowedTypes() {
      return this.canUploadVideosFF ? [] : SUPPORTED_TYPES;
    },
    allowedSize() {
      return this.canUploadVideosFF ? WILDCARD_MAX_FILE_SIZE_MB : MAX_FILE_SIZE_MB;
    },
  },
  methods: {
    addFiles(files) {
      const validFiles = [];
      const invalidFiles = [];
      [...files].forEach(file => {
        file.uid = uniqueId();
        file.uploaded = true;
        if (!typeValidate(file, this.allowedTypes)) {
          file.corrupted = 'type';
          invalidFiles.push(file);
        } else if (!sizeValidate(file, this.allowedSize)) {
          file.corrupted = 'size';
          invalidFiles.push(file);
        } else {
          validFiles.push(file)
        }
      })
      this.$refs.input.value = null;
      return { validFiles, invalidFiles };
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";

.upload-new-button {

  &__label {
    font-weight: 500;
    font-size: 13px;
    color: $blue-color-4;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  &__icon {
    margin-inline-end: 4px;
  }
  &__input {
    display: none;
  }

}
</style>
